module.exports = __webpack_public_path__ + "img/gn_07.f1fd6674.png";